import React, { useState } from "react";
import { useSelector } from "react-redux";
import { FaChevronRight } from "react-icons/fa";
import MemberInfoTip from "./MemberInfoTip";
import InlineAddBtn from "../InlineAddBtn";
import CollapsibleMemberGroup from "../CollapsibleMemberGroup";
import Member, { InviteMemberPicker } from "./member/member.component";
import permissions from "../../utils/permissions";
import "./members.styles.scss";

export default function PrMembers({
  station,
  space,
  memberData = [],
  people = {},
  pending = [],
}) {
  const currentUser = useSelector((state) => state.user.currentUser);
  const [expanded, setExpanded] = useState(true);
  const [invite, setInvite] = useState(false);
  const access = permissions.getPermissions(space, station, currentUser?.uid);
  const directUids = [...new Set(station.members || [])];
  const directSet = new Set(directUids);
  const workspaceMembers = access.canViewWorkspace
    ? memberData.filter((member) => !directSet.has(member.uid))
    : [];
  if (!access.canViewProject) return null;

  return (
    <details
      className="project-members-tree"
      style={{ "--member-tree-color": space?.color || "currentColor" }}
      open={expanded}
      onToggle={(event) => setExpanded(event.currentTarget.open)}
    >
      <summary>
        <div className="prj-members-Emojicon-container" style={{borderColor: space?.color || "lightgray"}}>
          <span className="EmojiIcon">{station.emojicon}</span>
        </div>
        <span className="members__project-title">{station.name}</span>
        <MemberInfoTip message="Explicit project assignments are listed here. Other workspace members may also have access. Owners and admins retain administrative powers." />
        <FaChevronRight
          className="members__project-chevron"
          size={12}
          aria-hidden="true"
        />
      </summary>

      <div className="project-members-tree__branches">
        {workspaceMembers.length > 0 && (
          <div className="project-members-tree__branch">
            <CollapsibleMemberGroup
              className="collapsible-member-group--connected"
              indent={4}
              title="Other workspace members"
              members={workspaceMembers}
              icon={
                <span
                  className="members__workspace-icon"
                  style={{ backgroundColor: space?.color }}
                >
                  {(space?.name || "W").charAt(0)}
                </span>
              }
            >
              {workspaceMembers.map((member) => (
                <div className="members__workspace-row" key={member.uid}>
                  <Member
                    member={member}
                    activeSpaceData={space}
                    activeSpaceId={space.spaceId}
                    station={station}
                    compact
                  />
                </div>
              ))}
            </CollapsibleMemberGroup>
          </div>
        )}
        {directUids.map((uid) => (
          <div className="project-members-tree__branch" key={uid}>
            <Member
              member={people[uid] || { uid }}
              activeSpaceData={space}
              activeSpaceId={space.spaceId}
              station={station}
            />
          </div>
        ))}
        {access.canManageProjectMembers && (
          <div className="project-members-tree__branch">
            <div className="members__button">
              <InlineAddBtn circleSize={36} onClick={() => setInvite(true)}>
                Add project members
              </InlineAddBtn>
            </div>
          </div>
        )}
      </div>
      {access.canManageProjectMembers && invite && (
        <InviteMemberPicker
          space={space}
          station={station}
          pending={pending}
          onClose={() => setInvite(false)}
        />
      )}
    </details>
  );
}
